import { Box, Typography } from "@material-ui/core"

// @ts-ignore
import {useTheme} from 'styled-components'

export interface IMetricCardProps {
  value: number
  title: string
}
export const MetricCard = ({ value, title }: IMetricCardProps) => {
  const theme = useTheme()
  return (
    <Box>
      <Typography variant="h5">
        <Box fontWeight="bold" color={theme.colors.primary}>
          {value || "--"}
        </Box>
      </Typography>
      <Typography variant="body2">
        <Box>{title}</Box>
      </Typography>
    </Box>
  )
}
